import React from "react";

const STATS = [
  { value: "6", suffix: "+ ans", label: "d'expertise au service de la transformation digitale" },
  { value: "50", suffix: "+", label: "projets livrés pour grands comptes en Afrique" },
  { value: "10", suffix: "", label: "ingénieurs certifiés répartis à Abidjan, Dakar, Paris" },
  { value: "100", suffix: "%", label: "missions livrées dans les délais contractuels" },
];

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative bg-[#0A1326] border-y border-[#D4AF37]/15"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-5 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-8 sm:gap-y-10 gap-x-5 md:gap-x-6">
          {STATS.map((s, i) => (
            <div
              key={s.label}
              data-testid={`stat-${i}`}
              className="relative pl-4 sm:pl-5 md:pl-7 border-l-2 border-[#D4AF37]"
            >
              <div className="font-display text-[36px] sm:text-4xl md:text-6xl font-black tracking-tight text-[#F5F5F5] leading-none">
                {s.value}
                <span className="text-[#D4AF37]">{s.suffix}</span>
              </div>
              <div className="mt-3 text-[12px] sm:text-sm md:text-[14px] text-[#F5F5F5]/65 max-w-[240px] leading-snug">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
